module.exports = __webpack_public_path__ + "static/media/rajivAmar.dbe21fcc.png";